import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL;
const API_KEY = 'BT001-REACH-TRCKS';


export async function sendEmail({ to, subject, body, apiKey = API_KEY, EmailTemplateId }) {
  const payload = {
    To: to,
    Subject: subject,
    HtmlContent: body,
    ...(EmailTemplateId ? { EmailTemplateId: Number(EmailTemplateId) } : {}),
  };
  try {
    const response = await axios.post(`${API_BASE}/emails/send`, payload, {
      headers: {
        'Content-Type': 'application/json-patch+json',
        'accept': '*/*',
        'X-API-Key': apiKey,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to send email');
  }
}

export async function sendBulkEmail({ to, subject, body, apiKey = API_KEY, EmailTemplateId }) {
  const payload = {
    To: to,
    Subject: subject,
    HtmlContent: body,
    ...(EmailTemplateId ? { EmailTemplateId: Number(EmailTemplateId) } : {}),
  };
  try {
    const response = await axios.post(`${API_BASE}/emails/send-bulk`, payload, {
      headers: {
        'Content-Type': 'application/json-patch+json',
        'accept': '*/*',
        'X-API-Key': apiKey,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to send bulk email');
  }
}

export const getAllEmailAddresses = async ({
   pageNumber = 1,
   pageSize = 10,
   searchTerm = '',
   sortBy = 'createdAt', 
   sortDescending = true,
   fullName,
   emailAddresses,
   isBlocked,
   isSubscribed,
   blockReason,
   metadata,
   blockedFrom,
   blockedTo
   } = {}) => {

  const queryParams = new URLSearchParams({
    pageNumber: pageNumber.toString(),
    pageSize: pageSize.toString(),
    sortBy,
    sortDescending: sortDescending.toString()
  });

  if (fullName) queryParams.append('fullName', fullName);
  if (emailAddresses) queryParams.append('emailAddresses', emailAddresses);
  if (isBlocked !== undefined && isBlocked !== '') queryParams.append('isBlocked', isBlocked.toString());
  if (isSubscribed !== undefined && isSubscribed !== '') queryParams.append('isSubscribed', isSubscribed.toString());
  if (blockReason) queryParams.append('blockReason', blockReason);
  if (metadata) queryParams.append('metadata', metadata);
  if (blockedFrom) queryParams.append('blockedFrom', blockedFrom + 'T00:00:00');
  if (blockedTo) queryParams.append('blockedTo', blockedTo + 'T23:59:59');

  const response = await fetch(`${API_BASE}/emails/addresses/all?${queryParams.toString()}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
      'X-API-Key': API_KEY
    }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch emails');
  }

  return response.json();
};

export const getAllEmailMessages = async ({ 
  pageNumber = 1,
  pageSize = 10,
  searchTerm = '',
  sortBy = 'createdAt',
  sortDescending = true,
  emailTemplateId,
  recipientEmail,
  senderEmail,
  subject,
  status,
  createdFrom,
  createdTo
    } = {}) => {
  const queryParams = new URLSearchParams({
    pageNumber: pageNumber.toString(),
    pageSize: pageSize.toString(),
    sortBy,
    sortDescending: sortDescending.toString()
  });

  if (emailTemplateId) queryParams.append('emailTemplateId', emailTemplateId);
  if (recipientEmail) queryParams.append('recipientEmail', recipientEmail);
  if (senderEmail) queryParams.append('senderEmail', senderEmail);
  if (subject) queryParams.append('subject', subject);
  if (status) queryParams.append('status', status);
  if (createdFrom) queryParams.append('createdFrom', createdFrom + 'T00:00:00');
  if (createdTo) queryParams.append('createdTo', createdTo + 'T23:59:59');

  const response = await fetch(`${API_BASE}/emails/messages/all?${queryParams.toString()}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
      'X-API-Key': API_KEY
    }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch emails');
  }

  return response.json();
};

export async function getEmailStats(apiKey = API_KEY) {
  try {
    const response = await axios.get(`${API_BASE}/request-analytics/stats/emails`, {
      headers: {
        'accept': '*/*',
        'X-API-Key': apiKey
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch email stats');
  }
}

export async function getEmailHistoryByEmailId(emailId) {
  try {
    const response = await axios.get(`${API_BASE}/emails/${emailId}/history`, {
      headers: {
        'accept': 'application/json, text/plain, */*',
        'X-API-Key': API_KEY
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch email history');
  }
}

export async function updateBlockStatus(data, apiKey = API_KEY) {
  try {
    const response = await axios.put(`${API_BASE}/emails/update-block-status`, data, {
      headers: {
        'Content-Type': 'application/json-patch+json',
        'X-API-Key': apiKey,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to update block status');
  }
}

export const updateEmail = async (updateData) => {
  try {
    const response = await fetch(`${API_BASE}/emails/update`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-API-Key': API_KEY
      },
      body: JSON.stringify(updateData)
    });

    if (!response.ok) {
      throw new Error('Failed to update email');
    }

    return await response.json();
  } catch (error) {
    console.error('Error updating email:', error);
    throw error;
  }
};

export const createBulkEmailAddresses = async (emailAddresses) => {
  try {
    const response = await fetch(`${API_BASE}/emails/addresses/bulk`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-API-Key': API_KEY
      },
      body: JSON.stringify(emailAddresses)
    });

    if (!response.ok) {
      throw new Error('Failed to create email addresses');
    }

    return await response.json();
  } catch (error) {
    console.error('Error creating email addresses:', error);
    throw error;
  }
}; 

export const exportEmailAddresses = async (params) => {
  const queryParams = new URLSearchParams();

  if (params.sortBy) queryParams.append('sortBy', params.sortBy);
  if (params.sortDescending !== undefined) queryParams.append('sortDescending', params.sortDescending.toString());
  if (params.exportTo) queryParams.append('exportTo', params.exportTo);
  if (params.searchTerm) queryParams.append('searchTerm', params.searchTerm);
  if (params.fullName) queryParams.append('fullName', params.fullName);
  if (params.emailAddresses) queryParams.append('emailAddresses', params.emailAddresses);
  if (params.isBlocked !== undefined && params.isBlocked !== '') queryParams.append('isBlocked', params.isBlocked.toString());
  if (params.isSubscribed !== undefined && params.isSubscribed !== '') queryParams.append('isSubscribed', params.isSubscribed.toString());
  if (params.blockReason) queryParams.append('blockReason', params.blockReason);
  if (params.metadata) queryParams.append('metadata', params.metadata);
  if (params.blockedFrom) queryParams.append('blockedFrom', params.blockedFrom + 'T00:00:00');
  if (params.blockedTo) queryParams.append('blockedTo', params.blockedTo + 'T23:59:59');

  const response = await fetch(`${API_BASE}/emails/addresses/all?${queryParams.toString()}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
      'X-API-Key': API_KEY
    }
  });

  if (!response.ok) {
    throw new Error('Failed to export email addresses');
  }

  const blob = await response.blob();
  return { data: blob };
};